const APIS = {
  DEFAULT_BRANCH: "logisticservice/api/branch/default-branch/",
  USER: "usermanagementservice/api/user/",
  USER_PROFILE: "logisticservice/api/user-profile/",
  RECEIVER_DETAIL: "/logisticservice/api/receiver-detail/",
  MERCHANT: "logisticservice/api/merchant/",
  CUSTOMER: "logisticservice/api/customer/",
  BRANCH: "usermanagementservice/api/branch/",
  INVOICE: "/invoiceservice/api/merchant-invoice/invoice-id/",
  DESTINATION: "logisticservice/api/location/list/",
  LOCATION: "logisticservice/api/location/",
  RUNSHEET: "/runsheetservice/api/runsheet/order-runsheet/",
  SERVICE_TYPE: "logisticservice/api/service-type/",
  TRASH_OREDR: "/logisticservice/api/order/trash/",
  PAYMENT_METHOD_TYPE: "logisticservice/api/payment-method/",
  PRODUCT_TYPE: "logisticservice/api/product-type/",
  REFERENCE_TYPE: "logisticservice/api/reference-type/",
  ORDER: "/logisticservice/api/order/",
  DELIVERED: "/logisticservice/api/order/change-to-delivered/",
  DELIVERY: "/vehiclemanifestservice/api/vehicle-manifest/delivery/",
  SUB_ORDER: "/logisticservice/api/sub-order/",
  MANIFEST: "/manifestservice/api/manifest/",
  VEHICLE_MANIFEST_ITEMS: "/vehiclemanifestservice/api/vehicle-manifest-item/",
  ASSIGN_DELIVERY: "/deliveryservice/api/order/assign-delivery/",
  DELIVERY_PARTNER: "/deliveryservice/api/delivery-partner-configurations/",
  DELIVERY_STATUS: "/logisticservice/api/delivery-settings/",
  STATUS: "logisticservice/api/status/",
  WAREHOUSE: "logisticservice/api/warehouse/",
  RIDER: "fleetservice/api/driver/",
  COMMENT: "/commentservice/api/comment/",
  REMARK: "logisticservice/api/remark/",
  STATUS_NEXT: "logisticservice/api/status/next-status/",
  ORDER_HISTORY: "/historyservice/api/history/",
  STAFF: "usermanagementservice/api/user/",
  PICKUPREQUEST: "/pickuprequestservice/api/pickup-request/",
  PICKUPREQUEST_ITEMS: "/pickuprequestservice/api/pickup-request-item/",
  PICKUPCOUNT: "/pickuprequestservice/api/pickup-request/count/",
  TAX_INVOICE: "invoiceservice/api/tax-invoice/",
  EXCELDOWNLOAD: "/logisticservice/api/order/email-order-excel/",
  TABLE_CONFIG: "/projectsettingsservice/api/column-definition/",
  SHIP_VIA: "/logisticservice/api/ship-via/",
};

export default APIS;
